import React, { useState } from 'react';
import axios from 'axios';
import { showError } from '../utils/alerts';
import { API_BASE_URL } from '../config';
import FechaSelector from '../components/FechaSelector';
import TablaBalance from '../components/TablaBalance';
import { generarPDF, generarExcel } from '../services/balanceExportService';
import '../styles/pages/VerBalance.css';

const VerBalance = ({ token, id_company }) => {
  const [mes, setMes] = useState('');
  const [anual, setAnual] = useState('');
  const [balanceData, setBalanceData] = useState([]);
  const [exportData, setExportData] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const handleDateChange = (selectedMes, selectedAnual) => {
    setMes(selectedMes);
    setAnual(selectedAnual);
  };

  const isMonthClosed = async (mes, anio) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
        params: { company: id_company, anio },
        headers: { Authorization: `Bearer ${token}` },
      });
      const monthData = res.data.find((item) => item.mes === parseInt(mes, 10));
      return monthData ? monthData.cerrado : false;
    } catch (error) {
      console.error('Error al verificar cierre mensual:', error);
      return false;
    }
  };

  const handleBuscarBalance = async () => {
    if (!mes || !anual) {
      showError('Por favor selecciona un mes y un año');
      return;
    }

    const cerrado = await isMonthClosed(mes, anual);
    if (!cerrado) {
      showError('El mes seleccionado no está cerrado. Debes cerrar el mes primero para ver el balance.');
      return;
    }

    try {
      const [balanceRes, exportRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/buscar-balance`, {
          params: { mes, anual, id_company },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE_URL}/api/balance/exportar`, {
          params: { mes, anual, id_company },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      if (balanceRes.data && balanceRes.data.length > 0) {
        setBalanceData(balanceRes.data);
        setExportData(exportRes.data);
      } else {
        showError('No se encontró el balance. Por favor, contacta al administrador.');
      }
    } catch (error) {
      console.error('Error al buscar balance:', error);
      showError(error.response?.data || 'Error al buscar balance');
    }
  };

  const handleDescargarPDF = async () => {
    if (!exportData) return;
    setLoadingPDF(true);
    try {
      generarPDF(exportData);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      showError('Error al generar el PDF');
    } finally {
      setLoadingPDF(false);
    }
  };

  const handleDescargarExcel = async () => {
    if (!exportData) return;
    setLoadingExcel(true);
    try {
      generarExcel(exportData);
    } catch (error) {
      console.error('Error al generar Excel:', error);
      showError('Error al generar el Excel');
    } finally {
      setLoadingExcel(false);
    }
  };

  return (
    <div className="ver-balance">
      <h1>Ver Balance General</h1>
      <FechaSelector onDateChange={handleDateChange} />
      <button className="btn-ver-balance" onClick={handleBuscarBalance}>Ver Balance General</button>

      {exportData && (
        <div className="balance-export-actions">
          <button
            onClick={handleDescargarPDF}
            disabled={loadingPDF}
            className="btn-export btn-export-pdf"
          >
            {loadingPDF ? 'Generando...' : 'Descargar PDF'}
          </button>
          <button
            onClick={handleDescargarExcel}
            disabled={loadingExcel}
            className="btn-export btn-export-excel"
          >
            {loadingExcel ? 'Generando...' : 'Descargar Excel'}
          </button>
        </div>
      )}

      <TablaBalance data={balanceData} />
    </div>
  );
};

export default VerBalance;
